import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchEmployee = createAsyncThunk("employee/fetchEmployee", async (searchText) => {
  const response = await api.post("/employee",{ search: searchText });
  return response.data.data;
});

export const addEmployee = createAsyncThunk(
  "employee/addEmployee",
  async (employeeData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", employeeData);
      dispatch(fetchEmployee());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "employee/deleteEmployee",
  async (employeeId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-employee/${employeeId}`);
      dispatch(fetchEmployee());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const employeeSlice = createSlice({
  name: "employeeData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openEmployeeModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeEmployeeModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployee.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmployee.rejected, (state, action) => {       
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEmployee.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addEmployee.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmployee.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteEmployee.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openEmployeeModal, closeEmployeeModal, clearError } = employeeSlice.actions;
export default employeeSlice.reducer;
export { employeeSlice };